<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-01-28 11:01:06
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-01-28 12:55:34
-->
<template>
  <div class="PasswordLogin">
    <Form
      :model="form"
      :rules="rules"
      v-model="regular"
    >
      <Input
        label="姓名"
        class="temr"
        v-model="form.borrowerName"
        :reg="rules.borrowerName"
        :maxlength="20"
        labelWidth="90px"
        type="text"
        placeholder="请输入姓名"
      />
      <Input
        label="身份证号"
        class="temr"
        v-model="form.borrowerIdentity"
        :reg="rules.borrowerIdentity"
        :maxlength="18"
        :toUpperCase="true"
        labelWidth="90px"
        placeholder="请输入身份证号"
      />
      <Input
        label="手机号"
        class="temr"
        v-model="form.legalPhone"
        :readonly="true"
        labelWidth="90px"
        placeholder="请输入手机号"
      />
      <message-code
        class="temr"
        label="验证码"
        :reg="rules.captcha"
        placeholder="请输入验证码"
        v-model="form.captcha"
        :params="{
          phone: form.legalPhone.replace(/\s+/g, ''),
          type: 9,
          method: 'getSmsWithLogin',
        }"
        :argementFlag="argementFlag"
      ></message-code>
    </Form>
    <Button
      :loading="loading"
      loadingText="提交中..."
      type="danger"
      text="提交认证"
      :disabled="!(regular && argementFlag)"
      class="nextStep"
      :click="nextStep"
    />
    <relaNameFooter :changeArgementFlag="changeArgementFlag" />
  </div>
</template>

<script>
import { rules } from '@/utils';
import Form from '@/components/Form.vue';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import relaNameFooter from '@/components/relaNameFooter/index.vue';
import MessageCode from '../login/components/MessageCode.vue';

export default {
  name: 'PasswordLogin',
  data() {
    return {
      type: 'password',
      form: {
        borrowerName: '',
        borrowerIdentity: '',
        legalPhone: '',
        captcha: '',
      },
      rules: {
        borrowerName: rules.borrowerName,
        borrowerIdentity: rules.borrowerIdentity,
        captcha: rules.legalPhone,
        captcha: rules.captcha,
      },
      loading: false,
      regular: false,
      argementFlag: false,
    };
  },
  components: {
    Form,
    Input,
    Button,
    MessageCode,
    relaNameFooter,
  },
  computed: {},
  mounted() {
    this.getData();
  },
  methods: {
    changeArgementFlag(val) {
      this.argementFlag = val;
    },
    getData() {
      this.$api.PublicPage.getUserPhone().then((res) => {
        const { data } = res;
        this.form = {
          ...this.form,
          legalPhone: data.phone,
        };
      });
    },
    nextStep() {
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      const {
        borrowerName, borrowerIdentity, legalPhone, captcha,
      } = this.form;
      this.$api.PublicPage.authentication({
        userName: borrowerName,
        identity: borrowerIdentity,
        phone: legalPhone,
        captcha,
      }).then((res) => {
        this.$toast.clear();
        if (res.success) {
          this.$toast.success('认证成功');
          // eslint-disable-next-line no-unused-expressions
          localStorage.getItem('returnPage')
            ? this.$router.push(localStorage.getItem('returnPage'))
            : this.$router.go(-1);
        } else {
          this.$toast.fail(res.returnMessage);
        }
      });
    },
  },
};
</script>
<style scoped>
.nextStep {
  margin-top: 12px;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;

  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.passwordBox {
  position: relative;
}
.PasswordLogin >>> .van-field__label {
  text-align: left;
  width: 74px;
  color: #1c2438

}
.bottom-info {
  position: absolute;
  bottom: 0;
  font-size: 13px;
  color: #b3b5b7;
  padding: 16px;
  text-align: left;
  pointer-events: none;
}
</style>
